import {QRCodeLimitLength, QRErrorCorrectLevel} from "./qr-constants";
import {defaultsDeep} from 'libs/defaults-deep';
import {QRCodeModel} from "./qr-code-model";
import {Drawing, DrawingCanvas} from './drawing';

interface Options {
    data: string,
    width: number,
    height: number,
    typeNumber: number,
    colorDark: string,
    colorLight: string,
    correctLevel: QRErrorCorrectLevel,
    useSVG: boolean;
}

export class QRCode {
    options: Options;
    drawing: Drawing;

    constructor(private el: HTMLElement, options: Partial<Options>) {
        this.el = el;

        this.options = defaultsDeep(options, {
            width: 256,
            height: 256,
            typeNumber: 4,
            colorDark: "#000000",
            colorLight: "#ffffff",
            useSVG: false,
            correctLevel: QRErrorCorrectLevel.H
        });

        this.drawing = new DrawingCanvas(el, this.options);
        this.makeCode();
    }

    makeCode() {
        const {data, correctLevel} = this.options;

        const qr = new QRCodeModel(
            getTypeNumber(data, correctLevel),
            correctLevel,
        );
        qr.addData(data);
        qr.make();
        this.drawing.draw(qr);
    }
}

function getUTF8Length(sText) {
    const replacedText = encodeURI(sText).toString().replace(/%[0-9a-fA-F]{2}/g, 'a');
    return replacedText.length + (replacedText.length != sText ? 3 : 0);
}

function getTypeNumber(sText, nCorrectLevel) {
    let nType = 1;
    const length = getUTF8Length(sText);

    for (let i = 0, len = QRCodeLimitLength.length; i <= len; i++) {
        let nLimit = 0;

        switch (nCorrectLevel) {
            case QRErrorCorrectLevel.L :
                nLimit = QRCodeLimitLength[i][0];
                break;
            case QRErrorCorrectLevel.M :
                nLimit = QRCodeLimitLength[i][1];
                break;
            case QRErrorCorrectLevel.Q :
                nLimit = QRCodeLimitLength[i][2];
                break;
            case QRErrorCorrectLevel.H :
                nLimit = QRCodeLimitLength[i][3];
                break;
        }

        if (length <= nLimit) {
            break;
        } else {
            nType++;
        }
    }

    if (nType > QRCodeLimitLength.length) {
        throw new Error("Too long data");
    }

    return nType;
}
